<template>
  <header class="order-tab">
    <div class="f26" @click="tab(1)">
      <span :class="defaultActived === 1 && 'actived'">预约</span>
    </div>
    <div class="f26" @click="tab(2)">
      <span :class="defaultActived === 2 && 'actived'">方案中</span>
      <div class="badge f24" v-if='num.waitConfirmNum'>{{num.waitConfirmNum}}</div>
    </div>
    <div class="f26" @click="tab(3)">
      <span :class="defaultActived === 3 && 'actived'">养护中</span>
      <div class="badge f24"  v-if='num.maintainingNum'>{{num.maintainingNum}}</div>
    </div>
    <div class="f26" @click="tab(4)">
      <span :class="defaultActived === 4 && 'actived'">待寄回</span>
      <div class="badge f24" v-if='num.waitDeliveryNum'>{{num.waitDeliveryNum}}</div>
    </div>
    <div class="f26" @click="tab(5)">
      <span :class="defaultActived === 5 && 'actived'">已完成</span>
      <div class="badge f24" v-if='num.doneNum'>{{num.doneNum}}</div>
    </div>
  </header>
</template>

<script>
  import orderApi from '@/axios/order'
  import zhugeObj from "@/assets/js/track";
  import { types } from 'util';
  export default {
    name: 'order-tab',
    data () {
      return {
        tabText:['预约','方案中','养护中','待寄回','已完成'],
        defaultActived: 1,
        num : {}
      }
    },
    created () {
      // this.defaultActived = parseInt(this.$route.params?.type) || 1;
      if(this.$route.params){
        this.defaultActived = parseInt(this.$route.params.type);
      }else{
        this.defaultActived = 1;
      }
      this.getNum();
    },
    methods: {
      getNum(){
        orderApi.getGoodsNumber().then((res)=>{
          this.num = res;
          // console.log(this.num)
        })
      },
      tab (type) {

        this.$router.replace({
          name: 'orderList',
          params : {
            type : type
          }
        })
      }
    },
    watch: {
      '$route' ({ params }) {
        this.defaultActived = params.type || 1;
      },
      defaultActived(val){
        zhugeObj.track({
            title: "订单列表-"+this.tabText[val-1]+'页点击',
        });
      }
    },
  }
</script>

<style scoped lang="scss">
  
  .order-tab {
    position: fixed;
    top:0;
    width: 100%;
    height: 100px;
    display: flex;
    border-bottom: 2px solid #eee;
    background: #fff;
    z-index: 99999;
    & > div {
      flex: 1;
      color: #999;
      height: 94px;
      line-height: 94px;
      text-align: center;
      position: relative;
      .actived {
        color: #333;
        position: relative;
        display: inline-block;
        border-bottom: 6px solid $theme-color;
      }
      .badge{
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: #F24949;
        text-align: center;
        line-height: 32px;
        position: absolute;
        top: 18px;
        right: 4px;
        color: #fff;
      }
    }
  }
</style>
